import classNames from 'classnames';
import React from 'react';
import FadeIn from 'react-fade-in';
import { createUseStyles } from 'react-jss';
import { layoutDefaults } from '../../utils/layout-defaults';

function NewAddressModalTitle({ title, subTitle, className, style }) {
  const classes = useStyles({ subTitle });

  return (
    <div className={classNames(classes.container, className)} style={style}>
      <FadeIn delay={150}>
        <div className={classes.title}>{title}</div>
      </FadeIn>
    </div>
  );
}

const useStyles = createUseStyles({
  container: {
    marginLeft: layoutDefaults.smallHorizontalMargin,
    marginRight: layoutDefaults.smallHorizontalMargin,
    // border: "1px solid white",
  },
  title: {
    fontSize: layoutDefaults.biggestFontSize - 2,
    fontWeight: 'bold',
    marginTop: -layoutDefaults.bigVerticalMargin,
  },
});

export { NewAddressModalTitle };
